import React, { FunctionComponent } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import { ImageSizeTypes, TintColor } from '../ImageInterfaces'
import { TestID } from '../../../utils/PropTypesDefinitions'
import Image from '..'
import PlayerImage from '../Player'

export type TagImageTypes = 'DEFAULT' | 'PLAYER'

type TagImageProps = {
    imageUrl?: string
    alt?: string
    width?: number
    height?: number
    size?: ImageSizeTypes
    tintColor?: TintColor
    type?: TagImageTypes
} & TestID

const TagImage: FunctionComponent<TagImageProps> = ({
    imageUrl,
    alt,
    width = 16,
    height = 16,
    size = 'L',
    tintColor,
    type = 'DEFAULT',
    testID,
}) => {
    if (!imageUrl) {
        return <FontelloIcon name="tag-label" color={tintColor || 'onyx-5'} fontSize="16px" />
    }
    if (type === 'PLAYER') {
        return (
            <PlayerImage imageUrl={imageUrl} alt={alt} width={width} testID={testID} size={size} />
        )
    }
    return (
        <Grid
            noExpand
            center
            width={width}
            height={height}
            backgroundColor="pearl-4"
            borderRadius={1}
        >
            <Image
                imageUrl={imageUrl}
                alt={alt}
                aspectRatio="1:1"
                width={width - 2}
                size={size}
                tintColor={tintColor}
            />
        </Grid>
    )
}
export default TagImage
